import React from 'react';
import PropTypes from 'prop-types';
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { langType, withLang } from '../../../i18n';
import {
  navigateTo
} from '../../../util';
import { clearSurveyAction } from '../../../actions';

const ReopenSurveyIconButton = ({
  route, surveyId, translate: t, disabled
}) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const reopenSurvey = () => {
    dispatch(clearSurveyAction());
    navigateTo(navigate, route, surveyId);
  };
  return (
    <button
      type="button"
      className="actionButton icon--item-edit"
      title={t('survey.reopen')}
      onClick={() => reopenSurvey()}
      disabled={disabled}
      data-cy="reopen-survey-icon-button"
    />
  );
};
const {
  string
} = PropTypes;

ReopenSurveyIconButton.propTypes = {
  surveyId: string.isRequired,
  ...langType
};

export default withLang(ReopenSurveyIconButton);
